.range-webinars-and-resources-tab__sdl-content {
  box-sizing: border-box;
}

.range-webinars-and-resources-tab__sdl-content *,
.range-webinars-and-resources-tab__sdl-content *::before,
.range-webinars-and-resources-tab__sdl-content *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 979px) {
  .range-webinars-and-resources-tab__sdl-content {
    margin-top: 20px;
  }
}

@media screen and (min-width: 980px) {
  .range-webinars-and-resources-tab__sdl-content {
    margin-top: 40px;
  }
}

.range-webinars-and-resources-tab__sdl-content a:hover {
  text-decoration: underline;
}